import { ContentFilterQueryParamKey } from '@as-react/common-types';
import { isNullOrUndefined } from '@as-react/common-utils';
import { put } from 'redux-saga/effects';
import { push, replace } from '../RouterReduxBindings';
import 'url-search-params-polyfill';
export const getURLParams = (urlState) => {
    const params = new URLSearchParams(window.location.search);
    Object.keys(urlState).forEach(urlStateKey => {
        if (!isNullOrUndefined(urlState[urlStateKey])) {
            switch (urlStateKey) {
                case 'filter':
                    if (urlState.filter.length > 0) {
                        if (typeof urlState.filter !== 'string') {
                            const flattendFilterValue = urlState.filter.reduce((accumulator, currentValue) => (accumulator += `&filter=${currentValue.filterOn}:${currentValue.filterValue}`), '');
                            params.set('filter', flattendFilterValue);
                        }
                        else {
                            params.set('filter', urlState.filter);
                        }
                    }
                    else {
                        params.delete(urlStateKey);
                    }
                    break;
                case 'defaultFilter':
                    break;
                case ContentFilterQueryParamKey.TYPE:
                    if (urlState.type.length > 0) {
                        const filterValue = urlState.type.reduce((acc, currentValue) => (acc += `&${urlStateKey}=${currentValue}`));
                        params.set(urlStateKey, filterValue);
                    }
                    else {
                        params.delete(urlStateKey);
                    }
                    break;
                default:
                    params.set(urlStateKey, urlState[urlStateKey].toString());
                    break;
            }
        }
        else {
            params.delete(urlStateKey);
        }
    });
    // Necessary encodeURI: prevents weird flicker issues with urls and encoded filter params
    return encodeURI(params.toString().replace(/\+/g, ' '));
};
export const getStoreData = (state) => ({
    lister: state.lister,
    filters: state.filters,
    url: state.url,
});
export const getContentStoreData = (state) => ({
    content: state.content,
    filters: state.filters,
    url: state.url,
});
export const getWishlistStoreData = (state) => ({
    basket: state.basket,
    compare: state.compare,
    wishList: state.wishList,
});
export function* pushRouterState(urlState, locationState) {
    const location = {
        search: getURLParams(urlState),
        pathname: window.location.pathname,
        state: locationState,
    };
    yield put(push(location));
}
export function* replaceRouterState(urlState, locationState) {
    const location = {
        search: getURLParams(urlState),
        pathname: window.location.pathname,
        state: locationState,
    };
    yield put(replace(location));
}
